export enum TaxTypes {
  External = 0,
  Internal = 1,
}

export function getTaxTypeName(value: TaxTypes): string {
  switch (value) {
    case TaxTypes.External: return '外税';
    case TaxTypes.Internal: return '内税';
  }
}

export function getTaxTypes(): TaxTypes[] {
  const list: TaxTypes[] = [];
  for (const item in TaxTypes) {
    if (!isNaN(Number(item))) {
      const num = Number(item);
      list.push(num);
    }
  }
  return list;
}
